import React, { useCallback, useState, Component } from 'react'

import RemoveCollectionFromPeople from '../../Services/Mutations/RemoveCollectionFromPeople'
import RemoveListFromPeople from '../../Services/Mutations/RemoveListFromPeople'
import UpdateSectionDetails from '../../Services/Mutations/UpdateSectionDetails'
import RemoveSection from '../../Services/Mutations/RemoveSection'
import UpdateSection from '../../Services/Mutations/UpdateSection'
import { Button, Modal } from 'react-bootstrap'
import { divide } from 'lodash-es'
import AddListToPeopleService from '../../Services/Mutations/AddListToPeopleService'
import AddPeopleToPeopleService from '../../Services/Mutations/AddPeopleToPeopleService'
import AddCollectionToPeopleService from '../../Services/Mutations/AddCollectionToPeopleService'
import AddPageToPeopleService from '../../Services/Mutations/AddPageToPeopleService'
const styles = {
  otherLabelStyle: { bottom: 0, right: '5px', position: 'absolute', cursor: 'default' },
}
class DraggableSections extends Component {
  constructor(props) {
    super(props)
    this.state = {
      modalVisible: false,
      itemTodelete: {},
      indexTodelete: '',
      label_Te: '',
      label_En: '',
      label_Hi: '',
      itemToEdit: {},
      showModal: false,
      showOtherLables: false,
      sectionDetails: props.sectionDetails,
      remeasure: '',
      boxes: [
        {
          id: 'Box-1',
          color: 'red',
          order: 1,
        },
        {
          id: 'Box-2',
          color: 'green',
          order: 2,
        },
        {
          id: 'Box-3',
          color: 'blue',
          order: 3,
        },
      ],
      dragId: '',
      confirmationModal: false,
      isMainList: false,
      sortType: 'date',
      selectedSectionColumns: '1',
      selectedSectionScroll: 'horizontal',
      addingNewItemsTo: 0,
      showAsSubPage: false,
      showAfter: '',
    }
    this.sectionColumns = [1, 2]
    this.sectionScroll = ['horizontal', 'vertical']
    this.myCallback = this.renderItem.bind(this)
  }
  componentDidUpdate(prevProps) {
    if (prevProps.sectionDetails != this.props.sectionDetails) {
      this.setState({
        sectionDetails: this.props.sectionDetails,
      })
    }
  }
  deleteSectionFromPage = async () => {
    const { itemTodelete, indexTodelete } = this.state
    this.setState({ modalVisible: false })
    if (itemTodelete.PK) {
      const input = {
        PK: itemTodelete.PK,
        SK: itemTodelete.SK,
      }
      console.log(input, 'input')
      //for page and people delete use remove section
      //for collection and list use seperate services

      if (itemTodelete.GSIRecordType == 'peopleCollections') {
        const data = await RemoveCollectionFromPeople(input)
        console.log(data, 'dataaaa peopleCollections')
        if (data.statusCode == 'A273') {
          this.props.displayToast('Removed Section From People Successfully', 'success')

          this.setState({ modalVisible: false })
          this.props.removeSection(indexTodelete)
        } else {
          this.props.displayToast('Failed To Remove Section From People', 'error')
        }
      } else if (itemTodelete.GSIRecordType == 'peopleLists') {
        const data = await RemoveListFromPeople(input)
        console.log(data, 'dataaaa peopleLists')

        if (data.statusCode == 'A269') {
          this.props.displayToast('Removed Section From People Successfully', 'success')

          this.setState({ modalVisible: false })
          this.props.removeSection(indexTodelete)
        } else {
          this.props.displayToast('Failed To Remove Section From People', 'error')
        }
      } else if (itemTodelete.GSIRecordType == 'pageSectionPeople') {
        const data = await RemoveSection(input)
        console.log(data, 'dataaaa peoplePages')

        if (data.statusCode == 'A293') {
          this.props.displayToast('Removed Section From People Successfully', 'success')

          this.setState({ modalVisible: false })
          this.props.removeSection(indexTodelete)
        } else {
          this.props.displayToast('Failed To Remove Section From People', 'error')
        }
      } else if (itemTodelete.GSIRecordType == 'peopleSectionPeople') {
        const data = await RemoveSection(input)
        console.log(data, 'dataaaa peoplePeople')

        if (data.statusCode == 'A293') {
          this.props.displayToast('Removed Section From People Successfully', 'success')

          this.setState({ modalVisible: false })
          this.props.removeSection(indexTodelete)
        } else {
          this.props.displayToast('Failed To Remove Section From People', 'error')
        }
      } else {
        this.props.removeSection(indexTodelete)
      }
    } else {
      this.props.displayToast('Removed Section From People Successfully', 'success')

      this.props.removeSection(indexTodelete)
    }
  }
  handleEnSectionLabel = (e) => {
    const sectionLabel = e.target.value
    this.setState({ label_En: sectionLabel })
  }
  handleTeSectionLabel = (e) => {
    const sectionLabel = e.target.value

    this.setState({ label_Te: sectionLabel })
  }
  handleHiSectionLabel = (e) => {
    const sectionLabel = e.target.value

    this.setState({ label_Hi: sectionLabel })
  }
  updateLabels = async () => {
    const {
      itemToEdit,
      label_En,
      label_Hi,
      label_Te,
      sortType,
      selectedSectionColumns,
      selectedSectionScroll,
    } = this.state
    const item = this.state.sectionDetails[itemToEdit]
    if (item.SK || item.sectionAdded) {
      const SK = item.sectionType == 'collection' ? item.collectionValue : item.listValue
      const input = {
        PK: item.PK ? item.PK : item.peopleValue,
        SK: SK,
        sectionLabel_Te: label_Te,
        sectionLabel_En: label_En,
        sectionLabel_Hi: label_Hi,
        sectionColumns: selectedSectionColumns,
        sectionScroll: selectedSectionScroll,
        sortBy: sortType,
        displayAfter: parseInt(this.state.showAfter),
      }
      if ('pageCollections pageLists peopleCollections peopleLists'.includes(item.GSIRecordType)) {
        input.sectionConfigType = this.state.isMainList ? 'mainList' : 'NO'
      }
      if ('pageLists peopleLists'.includes(item.GSIRecordType)) {
        input.showAsSubPage = this.state.showAsSubPage
      }
      console.log(input, 'inputaa update section lables')
      const data = await UpdateSectionDetails(input)
      if (data.statusCode == 'A276') {
        console.log(data, 'dataaa update section lables')
        this.setState({ showModal: false })
        this.props.UpdateSectionDetails(itemToEdit, label_Hi, label_Te, label_En, input)
      }
    } else {
      const input = {
        sectionColumns: selectedSectionColumns,
        sectionScroll: selectedSectionScroll,
        sortBy: sortType,
        displayAfter: parseInt(this.state.showAfter),
        sectionConfigType: this.state.isMainList ? 'mainList' : 'NO',
        showAsSubPage: this.state.showAsSubPage,
      }
      const sectionDetails = this.state.sectionDetails

      sectionDetails[itemToEdit].sectionLabel_En = label_En
      sectionDetails[itemToEdit].sectionLabel_Hi = label_Hi
      sectionDetails[itemToEdit].sectionLabel_Te = label_Te
      sectionDetails[itemToEdit].sectionColumns = selectedSectionColumns
      sectionDetails[itemToEdit].sectionScroll = selectedSectionScroll
      sectionDetails[itemToEdit].sortBy = sortType
      sectionDetails[itemToEdit].displayAfter = parseInt(this.state.showAfter)
      sectionDetails[itemToEdit].sectionConfigType = this.state.isMainList ? 'mainList' : 'NO'
      sectionDetails[itemToEdit].showAsSubPage = this.state.showAsSubPage

      this.setState({
        sectionDetails: sectionDetails,
      })
      this.setState({ showModal: false })
      this.props.UpdateSectionDetails(itemToEdit, label_Hi, label_Te, label_En, input)
    }
  }
  showConfirmationModal = (item, renderingItem, type, itemIndex) => {
    const removeItemDetails = {
      item,
      renderingItem,
      type,
      itemIndex,
    }
    this.setState({
      confirmationModal: true,
      removeItemDetails,
    })
  }
  removeItemfromSection = async () => {
    const { item, type, renderingItem, itemIndex } = this.state.removeItemDetails
    const sectionDetails = this.state.sectionDetails
    const findIndex = sectionDetails[itemIndex].sectionDetails.findIndex(
      (section) => section.SK == item.SK
    )
    sectionDetails[itemIndex].sectionDetails.splice(findIndex, 1)
    if (renderingItem.PK) {
      const ids = sectionDetails[itemIndex].sectionDetails.map((item) => item.SK)
      const input = {
        PK: renderingItem.PK,
        SK: renderingItem.SK,
      }

      if (type == 'page') {
        input.pages = ids
      } else if (type == 'people') {
        input.people = ids
      }
      console.log(input, 'delete section inputttt')
      const data = await UpdateSection(input)
      console.log(data, 'dataaa')
      if (data.statusCode == 'A292') {
        this.props.updatePeopleSections(sectionDetails)
        this.setState({
          confirmationModal: false,
        })
      }
    } else {
      this.props.updatePeopleSections(sectionDetails)
      this.setState({
        confirmationModal: false,
      })
    }
  }
  saveSection = async (index) => {
    const section = this.state.sectionDetails[index]
    const urlParams = window.location.href.split('?')
    const peopleValue = urlParams && urlParams[1]
    let data
    if (section.sectionType == 'list') {
      section.peopleValue = 'people#' + peopleValue

      section.listValue = section.listValue.listValue
      const input = {
        listValue: section.listValue,
        sectionPosition: index + 1,
        peopleValue: section.peopleValue,
        sectionLabel_En: section.sectionLabel_En,
        sectionLabel_Hi: section.sectionLabel_Hi,
        sectionLabel_Te: section.sectionLabel_Te,
        sortBy: section.sortBy,
        sectionColumns: section.sectionColumns,
        sectionScroll: section.sectionScroll,
        displayAfter: parseInt(section.displayAfter),
        showAsSubPage: section.showAsSubPage,
        sectionConfigType: section.sectionConfigType,
      }

      console.log(input, 'input=======')
      data = await AddListToPeopleService(input)
      if (data.statusCode == 'A268') {
        this.props.displayToast('Added List to People Successfully', 'success')
      } else {
        this.props.displayToast('Failed to add  List to People ', 'error')
      }
      console.log(data, 'dataaaaa list')
      this.state.sectionDetails[index].sectionAdded = true
      this.setState({ sectionDetails: this.state.sectionDetails })
    }
    if (section.sectionType == 'collection') {
      section.peopleValue = 'people#' + peopleValue

      section.collectionValue = section.collectionValue.collectionValue
      const input = {
        collectionValue: section.collectionValue,
        sectionPosition: index + 1,
        peopleValue: section.peopleValue,
        sectionLabel_En: section.sectionLabel_En,
        sectionLabel_Hi: section.sectionLabel_Hi,
        sectionLabel_Te: section.sectionLabel_Te,
        sortBy: section.sortBy,
        sectionColumns: section.sectionColumns,
        sectionScroll: section.sectionScroll,
        displayAfter: parseInt(section.displayAfter),
        showAsSubPage: section.showAsSubPage,
        sectionConfigType: section.sectionConfigType,
      }
      data = await AddCollectionToPeopleService(input)
      if (data.statusCode == 'A272') {
        this.props.displayToast('Added Collection to People Successfully', 'success')
      } else {
        this.props.displayToast('Failed to add  Collection to People ', 'error')
      }
      console.log(data, 'dataaaaa collection')

      this.state.sectionDetails[index].sectionAdded = true
      this.setState({ sectionDetails: this.state.sectionDetails })
    }
    if (section.sectionType == 'people') {
      const peopleIds = []
      section.sectionDetails.map((item, itemindex) => {
        peopleIds.push(item.peopleValue)
      })
      section.peopleValue = 'people#' + peopleValue
      section.addedpeople = peopleIds
      const input = {
        sectionPosition: index + 1,
        addedpeople: peopleIds,
        peopleValue: section.peopleValue,
        sectionLabel_En: section.sectionLabel_En,
        sectionLabel_Hi: section.sectionLabel_Hi,
        sectionLabel_Te: section.sectionLabel_Te,
        sortBy: section.sortBy,
        sectionColumns: section.sectionColumns,
        sectionScroll: section.sectionScroll,
        displayAfter: parseInt(section.displayAfter),
        showAsSubPage: section.showAsSubPage,
        sectionConfigType: section.sectionConfigType,
      }
      data = await AddPeopleToPeopleService(input)
      if (data.statusCode == 'A290') {
        this.props.displayToast('Added People to People Successfully', 'success')
      } else {
        this.props.displayToast('Failed to add  People to People ', 'error')
      }
      console.log(data, 'dataaaaa people')

      this.state.sectionDetails[index].sectionAdded = true
      this.setState({ sectionDetails: this.state.sectionDetails })
    }
    if (section.sectionType == 'page') {
      const pageIds = []
      section.sectionDetails.map((item, itemindex) => {
        pageIds.push(item.pageValue)
      })
      section.peopleValue = 'people#' + peopleValue
      section.pages = pageIds
      const input = {
        sectionPosition: index + 1,
        pages: pageIds,
        peopleValue: section.peopleValue,
        sectionLabel_En: section.sectionLabel_En,
        sectionLabel_Hi: section.sectionLabel_Hi,
        sectionLabel_Te: section.sectionLabel_Te,
        sortBy: section.sortBy,
        sectionColumns: section.sectionColumns,
        sectionScroll: section.sectionScroll,
        displayAfter: parseInt(section.displayAfter),
        showAsSubPage: section.showAsSubPage,
        sectionConfigType: section.sectionConfigType,
      }
      data = await AddPageToPeopleService(input)
      if (data.statusCode == 'A291') {
        this.props.displayToast('Added Page to People Successfully', 'success')
      } else {
        this.props.displayToast('Failed to add  Page to People ', 'error')
      }
      console.log(data, 'dataaaaa page')

      this.state.sectionDetails[index].sectionAdded = true
      this.setState({ sectionDetails: this.state.sectionDetails })
    }
  }
  renderItem = (item, index) => {
    let type =
      item.SK && item.SK.includes('collection#')
        ? 'collection'
        : item.SK && item.SK.includes('list#')
        ? 'list'
        : ''
    if (item.SK && item.SK.includes('section#')) {
      type = item.GSIRecordType == 'pageSectionPeople' ? 'page' : 'people'
    }
    if (item.sectionType) {
      type = item.sectionType
    }
    const name = type == 'list' ? item.listName_En : type == 'collection' ? item.collectionName : ''
    const itemIndex = index
    const labelValue =
      item.sectionLabel_En != null
        ? item.sectionLabel_En
        : item.sectionLabel_Te != null
        ? item.sectionLabel_Te
        : item.sectionLabel_Hi
    return (
      // <div onLongPress={drag}>
      <div>
        <div
          class='actionIcons row'
          style={{ right: '10px', position: 'absolute', cursor: 'default' }}
        >
          <div
            class='column'
            style={{ width: '25px', marginRight: '5px' }}
            onClick={() => {
              this.setState({
                label_Te: item.sectionLabel_Te,
                label_En: item.sectionLabel_En,
                label_Hi: item.sectionLabel_Hi,
                itemToEdit: itemIndex,
                selectedSectionColumns: item.sectionColumns ? item.sectionColumns : 1,
                selectedSectionScroll: item.sectionScroll ? item.sectionScroll : 'horizontal',
                showAsSubPage: item.showAsSubPage ? item.showAsSubPage : false,
                showAfter:
                  item.displayAfter != '' && item.displayAfter != null
                    ? item.displayAfter.toString()
                    : '',
                isMainList: item.sectionConfigType == 'mainList' ? true : false,
                sortType: item.sortBy ? item.sortBy : 'date',
                showModal: true,
              })
            }}
          >
            <i class='fas fa-pencil-alt' />
          </div>
          <div
            class='column'
            style={{ width: '25px', marginRight: '5px' }}
            onClick={() => {
              this.setState({
                modalVisible: true,
                indexTodelete: index,
                itemTodelete: item,
              })
            }}
          >
            <i class='fas fa-trash' />
          </div>
          {item.sectionAdded || item.SK ? null : (
            <div
              class='column'
              style={{ width: '40px' }}
              onClick={() => this.saveSection(itemIndex)}
            >
              <i class='fas fa-upload' />
            </div>
          )}
        </div>
        <div style={{ marginBottom: '35px' }}>
          <div>
            <div>
              <text>{`Type: ${type}`}</text>
            </div>
            {type == 'collection' ? (
              <div>
                <text>{`Name: ${
                  name
                    ? name
                    : item.collectionValue.collectionName
                    ? item.collectionValue.collectionName
                    : ''
                }`}</text>
              </div>
            ) : null}
            {type == 'list' ? (
              <div>
                <div>
                  <div style={{ marginBottom: '5px' }}>
                    <text>{'Name_En '}</text>
                    <input
                      type='text'
                      disabled
                      value={
                        item.listName_En
                          ? item.listName_En
                          : item.listValue.listName
                          ? item.listValue.listName
                          : ''
                      }
                      placeholder='Section Name PlaceHolder'
                    ></input>
                  </div>
                  <div style={{ marginBottom: '5px' }}>
                    <text>{'Name_Te '}</text>
                    <input
                      type='text'
                      disabled
                      value={
                        item.listName_Te
                          ? item.listName_Te
                          : item.listValue.listName
                          ? item.listValue.listName
                          : ''
                      }
                      placeholder='Section Name PlaceHolder'
                    ></input>
                  </div>
                  <div style={{ marginBottom: '5px' }}>
                    <text>{'Name_Hi'}</text>
                    <input
                      type='text'
                      disabled
                      value={
                        item.listName_Hi
                          ? item.listName_Hi
                          : item.listValue.listName
                          ? item.listValue.listName
                          : ''
                      }
                      placeholder='Section Name PlaceHolder'
                    ></input>
                  </div>
                </div>
              </div>
            ) : null}

            <div>
              {item.sectionDetails && item.sectionDetails.length > 0
                ? item.sectionDetails.map((innerSection, index) => {
                    const name = type == 'page' ? innerSection.pageTitle : innerSection.peopleName
                    return (
                      <div style={{ display: 'flex' }} for={`sectionDetails_${index}`}>
                        <text>{name}</text>
                        <div
                          style={{ marginLeft: '5px' }}
                          onClick={() => {
                            this.showConfirmationModal(innerSection, item, type, itemIndex)
                          }}
                        >
                          <i class='fas fa-times-circle' />
                        </div>
                      </div>
                    )
                  })
                : null}
            </div>
          </div>

          {!this.state.showOtherLables && (
            <div>
              <div>
                <div style={{ marginBottom: '5px' }}>
                  <text>{'Section Label '}</text>
                  <input
                    type='text'
                    disabled
                    value={labelValue}
                    placeholder='Section Label PlaceHolder'
                  ></input>
                </div>
              </div>

              {!this.state.showOtherLables ? (
                <div
                  style={styles.otherLabelStyle}
                  class='otherLabels'
                  onClick={() => this.setState({ showOtherLables: true })}
                >
                  <text>See Other Labels</text>
                </div>
              ) : null}
            </div>
          )}
          {this.state.showOtherLables ? (
            <div>
              <div style={{ marginBottom: '5px' }}>
                <text>{'En Label '}</text>
                <input
                  type='text'
                  disabled
                  value={item.sectionLabel_En}
                  placeholder='En Label PlaceHolder'
                ></input>
              </div>
              <div style={{ marginBottom: '5px' }}>
                <text>{'Te Label '}</text>
                <input
                  type='text'
                  disabled
                  value={item.sectionLabel_Te}
                  placeholder='Te Label PlaceHolder'
                ></input>
              </div>
              <div style={{ marginBottom: '5px' }}>
                <text>{'Hi Label '}</text>
                <input
                  type='text'
                  disabled
                  value={item.sectionLabel_Hi}
                  placeholder='Hi Label PlaceHolder'
                ></input>
              </div>
              <div
                style={styles.otherLabelStyle}
                class='otherLabels'
                onClick={() => this.setState({ showOtherLables: false })}
              >
                <text>Hide Other Labels </text>
              </div>
            </div>
          ) : null}
        </div>
      </div>
    )
  }
  // myCallback = this.renderItem.bind(this)
  keyExtractor = (item) => {
    return `draggable-item-${item.SK}-${item.sectionPosition}`
  }
  updateSortorder = (data) => {
    this.setState({ sectionDetails: data })
    this.props.updateSortedOrder(data)
  }
  handleDrag = (ev) => {
    this.setState({ dragId: ev.currentTarget.id })
  }

  handleDrop = (ev) => {
    const { sectionDetails, dragId } = this.state
    const dragItem = sectionDetails.find((item) => item.SK === dragId)
    const dropItem = sectionDetails.find((item) => item.SK === ev.currentTarget.id)
    const dragIndex = sectionDetails.findIndex((section) => section.SK == dragId)
    const dropIndex = sectionDetails.findIndex((section) => section.SK == ev.currentTarget.id)
    sectionDetails[dropIndex] = dragItem
    sectionDetails[dragIndex] = dropItem
    this.setState({ sectionDetails: sectionDetails }, () => {
      this.props.updateSortedOrder(this.state.sectionDetails)
    })
  }
  handleSortOption = async (sortValue) => {
    const { sortType } = this.state
    if (sortValue != sortType) {
      this.setState({ sortType: sortValue })
    }
  }
  handleShowAfter = (e) => {
    const showAfter = e.target.value
    this.setState({ showAfter })
  }
  toggleMainList = () => {
    this.setState({ isMainList: !this.state.isMainList })
  }
  selectSectionColumn = (sectionColumn) => {
    this.setState({ selectedSectionColumns: sectionColumn })
  }
  selectSectionScroll = (sectionScroll) => {
    this.setState({ selectedSectionScroll: sectionScroll })
  }
  toggleShowAsSubPage = () => {
    this.setState({ showAsSubPage: !this.state.showAsSubPage })
  }

  render() {
    const { sortType, showAfter, itemToEdit } = this.state

    return (
      <div>
        <div className='sectionsItemsContainer'>
          {this.state.sectionDetails &&
            this.state.sectionDetails.map((item, index) => (
              <div
                class='col-md-5 sectionItems'
                draggable={true}
                id={item.SK}
                onDragOver={(ev) => ev.preventDefault()}
                onDragStart={this.handleDrag}
                onDrop={this.handleDrop}
                style={{
                  border: '1px solid',
                  borderColor: '#999999',
                  marginBottom: '5px',
                  cursor: 'grab',
                }}
              >
                {this.renderItem(item, index)}
              </div>
            ))}
        </div>
        <div style={{ flex: 1 }}>
          <Modal
            show={this.state.modalVisible}
            onHide={() => this.setState({ modalVisible: false })}
          >
            <Modal.Body>Are You Sure You Want To Remove This Section ?</Modal.Body>
            <Modal.Footer>
              <Button onClick={() => this.setState({ modalVisible: false })}>Cancel</Button>
              <Button onClick={() => this.deleteSectionFromPage()}>Delete</Button>
            </Modal.Footer>
          </Modal>
          <Modal
            show={this.state.confirmationModal}
            onHide={() => this.setState({ confirmationModal: false })}
          >
            <Modal.Body>Are You Sure You Want To Remove Item From This Section ?</Modal.Body>
            <Modal.Footer>
              <Button onClick={() => this.setState({ confirmationModal: false })}>Cancel</Button>
              <Button onClick={() => this.removeItemfromSection()}>Delete</Button>
            </Modal.Footer>
          </Modal>

          <Modal show={this.state.showModal} onHide={() => this.setState({ showModal: false })}>
            <Modal.Header>
              <label>Update Section Labels</label>
            </Modal.Header>

            <Modal.Body>
              <div style={{ marginBottom: '5px' }}>
                <text>{'En Label '}</text>
                <div>
                  <input
                    type='text'
                    onChange={(value) => {
                      this.handleEnSectionLabel(value)
                    }}
                    value={this.state.label_En}
                    placeholder='En Label Placeholder'
                  ></input>
                </div>
              </div>
              <div style={{ marginBottom: '5px' }}>
                <text>{'Te Label '}</text>
                <div>
                  <input
                    type='text'
                    onChange={(value) => {
                      this.handleTeSectionLabel(value)
                    }}
                    value={this.state.label_Te}
                    placeholder='Te Label PlaceHolder'
                  ></input>
                </div>
              </div>
              <div style={{ marginBottom: '5px' }}>
                <text>{'Hi Label'}</text>
                <div>
                  <input
                    type='text'
                    onChange={(value) => {
                      this.handleHiSectionLabel(value)
                    }}
                    value={this.state.label_Hi}
                    placeholder='Hi Label PlaceHolder'
                  ></input>
                </div>
              </div>
              <div>
                {(this.state.sectionDetails[itemToEdit] &&
                  this.state.sectionDetails[itemToEdit].sectionType == 'list') ||
                (this.state.sectionDetails[itemToEdit] &&
                  this.state.sectionDetails[itemToEdit].PK &&
                  this.state.sectionDetails[itemToEdit].PK == 'lists') ||
                (this.state.sectionDetails[itemToEdit] &&
                  'pageLists peopleLists'.includes(
                    this.state.sectionDetails[itemToEdit].GSIRecordType
                  )) ? (
                  <div>
                    <div>
                      <text>Sort By</text>
                    </div>
                    <div style={styles.typeradioItems}>
                      <div style={styles.radioContainerStyle}>
                        <div>
                          <input
                            value={'By DateTime'}
                            type='radio'
                            checked={sortType == 'date'}
                            onChange={() => this.handleSortOption('date')}
                          ></input>
                          <text for={'By DateTime'}>{'By DateTime'}</text>
                        </div>
                        <div>
                          <input
                            value={'By Points'}
                            type='radio'
                            checked={sortType == 'points'}
                            onChange={() => this.handleSortOption('points')}
                          ></input>
                          <text for={'By Points'}>{'By Points'}</text>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : null}

                {(this.state.sectionDetails[itemToEdit] &&
                  'pageLists peopleLists'.includes(
                    this.state.sectionDetails[itemToEdit].GSIRecordType
                  )) ||
                (this.state.sectionDetails[itemToEdit] &&
                  this.state.sectionDetails[itemToEdit].sectionType == 'list') ||
                (this.state.sectionDetails[itemToEdit] &&
                  this.state.sectionDetails[itemToEdit].PK &&
                  this.state.sectionDetails[itemToEdit].PK == 'lists') ? (
                  <div>
                    <div>
                      <div className='custom-control custom-switch'>
                        <input
                          type='checkbox'
                          className='custom-control-input'
                          onChange={() => this.toggleShowAsSubPage()}
                          checked={this.state.showAsSubPage}
                          id='showAsSubPage'
                          readOnly
                        />
                        <label className='custom-control-label' htmlFor='showAsSubPage'>
                          Show As Sub Page
                        </label>
                      </div>
                    </div>
                  </div>
                ) : null}
                <div>
                  {((this.state.sectionDetails[itemToEdit] &&
                    'pageCollections pageLists pageSectionPages peopleSectionPages peopleCollections peopleLists peopleSectionPeople pageSectionPeople'.includes(
                      this.state.sectionDetails[itemToEdit].GSIRecordType
                    )) ||
                    this.state.sectionDetails[itemToEdit]) && (
                    <div>
                      <div>
                        <text>Section Columns</text>
                        <div>
                          {this.sectionColumns.map((itemType) => {
                            return (
                              <div className='col-md-3'>
                                <input
                                  value={itemType}
                                  type='radio'
                                  checked={this.state.selectedSectionColumns == itemType}
                                  onChange={() => this.selectSectionColumn(itemType)}
                                ></input>
                                <text for={itemType}>{itemType}</text>
                              </div>
                            )
                          })}
                        </div>
                      </div>
                      <div>
                        <text>Section Scroll</text>
                        <div>
                          {this.sectionScroll.map((itemType) => {
                            return (
                              <div className='col-md-3'>
                                <input
                                  value={itemType}
                                  type='radio'
                                  checked={this.state.selectedSectionScroll == itemType}
                                  onChange={() => this.selectSectionScroll(itemType)}
                                ></input>
                                <text for={itemType}>{itemType}</text>
                              </div>
                            )
                          })}
                        </div>
                      </div>
                      <div>
                        <text>{'Show After Number Of Records'}</text>
                        <div>
                          <input
                            type='text'
                            value={showAfter}
                            onChange={(e) => {
                              this.handleShowAfter(e)
                            }}
                            placeholder='Enter Show After Number Of Records'
                          ></input>
                        </div>
                      </div>
                      {((this.state.sectionDetails[itemToEdit] &&
                        'pageCollections pageLists peopleCollections peopleLists'.includes(
                          this.state.sectionDetails[itemToEdit].GSIRecordType
                        )) ||
                        this.state.sectionDetails[itemToEdit]) && (
                        <div>
                          <div className='custom-control custom-switch'>
                            <input
                              type='checkbox'
                              className='custom-control-input'
                              onChange={() => this.toggleMainList()}
                              checked={this.state.isMainList}
                              id='isMainList'
                              readOnly
                            />
                            <label className='custom-control-label' htmlFor='isMainList'>
                              Is Main List
                            </label>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button onClick={() => this.setState({ showModal: false })}>Cancel</Button>
              <Button onClick={() => this.updateLabels()}>Update</Button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    )
  }
}
export default DraggableSections
